import { NodeCard } from 'components/HierarchicalTrees/TreeNodeCard';

export const buildEntityToFunctionReverseTree = (data: any[]): any[] => {
  const getKey = (...parts: any[]) =>
    parts.map((p) => (p == null ? 'null' : String(p))).join('|');

  const normalize = (v: any) => (v == null ? '' : String(v));

  const createNode = (
    key: string,
    label: string,
    value: any,
    info?: any,
    children: any[] = [],
  ) => ({
    key,
    title: <NodeCard label={label} value={normalize(value)} info={info} />,
    children,
  });

  const emptyNode = (label: string, parentKey: string, index: number) =>
    createNode(
      getKey('empty', label, parentKey, index),
      label,
      '',
      undefined,
      [],
    );

  return (Array.isArray(data) ? data : []).map((entityItem, eIndex) => {
    const children: any[] = [];

    const serviceDataNodes =
      (entityItem.ict_service_data || []).length > 0
        ? entityItem.ict_service_data.map((dataItem: any, dIndex: number) => {
            const systemNodes =
              (dataItem.systems || []).length > 0
                ? dataItem.systems.map((system: any, sysIndex: number) => {
                    const serviceNodes =
                      (system.services || []).length > 0
                        ? system.services.map(
                            (service: any, sIndex: number) => {
                              const contractNodes =
                                (service.contracts || []).length > 0
                                  ? service.contracts.map(
                                      (contract: any, cIndex: number) => {
                                        const tppNodes =
                                          (contract.third_parties || [])
                                            .length > 0
                                            ? contract.third_parties.map(
                                                (tp: any, tIndex: number) =>
                                                  createNode(
                                                    getKey(
                                                      'tpp',
                                                      tp.third_party_id,
                                                      contract.contract_id,
                                                      tIndex,
                                                    ),
                                                    'Third Party Service Provider',
                                                    tp.third_party_name,
                                                  ),
                                              )
                                            : [
                                                emptyNode(
                                                  'Third Party Service Provider',
                                                  contract.contract_id,
                                                  cIndex,
                                                ),
                                              ];

                                        return createNode(
                                          getKey(
                                            'contract',
                                            contract.contract_id,
                                            service.service_id,
                                            cIndex,
                                          ),
                                          'Contract',
                                          contract.contract_name,
                                          undefined,
                                          tppNodes,
                                        );
                                      },
                                    )
                                  : [
                                      emptyNode(
                                        'Contract',
                                        service.service_id,
                                        sIndex,
                                      ),
                                    ];

                              return createNode(
                                getKey(
                                  'service',
                                  service.service_id,
                                  system.system_id,
                                  sIndex,
                                ),
                                'ICT Service',
                                service.service_name,
                                undefined,
                                contractNodes,
                              );
                            },
                          )
                        : [
                            emptyNode(
                              'ICT Service',
                              system.system_id,
                              sysIndex,
                            ),
                          ];

                    return createNode(
                      getKey(
                        'svc-system',
                        system.system_id,
                        dataItem.data_id,
                        sysIndex,
                      ),
                      'ICT Service Systems',
                      system.system_name,
                      undefined,
                      serviceNodes,
                    );
                  })
                : [emptyNode('ICT Service Systems', dataItem.data_id, dIndex)];

            return createNode(
              getKey('svc-data', dataItem.data_id, eIndex, dIndex),
              'ICT Service Data',
              dataItem.description,
              {
                location_of_data_at_rest_name:
                  dataItem.location_of_data_at_rest_name,
                location_of_data_management_name:
                  dataItem.location_of_data_management_name,
                site: dataItem.site,
              },
              systemNodes,
            );
          })
        : [emptyNode('ICT Service Data', entityItem.entity_id, eIndex)];

    const functionDataNodes =
      (entityItem.ict_function_data || []).length > 0
        ? entityItem.ict_function_data.map((dataItem: any, dIndex: number) => {
            const systemNodes =
              (dataItem.systems || []).length > 0
                ? dataItem.systems.map((system: any, sysIndex: number) => {
                    const functionNodes =
                      (system.functions || []).length > 0
                        ? system.functions.map((fn: any, fIndex: number) =>
                            createNode(
                              getKey(
                                'function',
                                fn.function_id,
                                system.system_id,
                                fIndex,
                              ),
                              'Function',
                              fn.function_name,
                            ),
                          )
                        : [emptyNode('Function', system.system_id, sysIndex)];

                    return createNode(
                      getKey(
                        'func-system',
                        system.system_id,
                        dataItem.data_id,
                        sysIndex,
                      ),
                      'Function Systems',
                      system.system_name,
                      undefined,
                      functionNodes,
                    );
                  })
                : [emptyNode('Function Systems', dataItem.data_id, dIndex)];

            return createNode(
              getKey('func-data', dataItem.data_id, eIndex, dIndex),
              'ICT Function Data',
              dataItem.description,
              {
                location_of_data_at_rest_name:
                  dataItem.location_of_data_at_rest_name,
                location_of_data_management_name:
                  dataItem.location_of_data_management_name,
                site: dataItem.site,
              },
              systemNodes,
            );
          })
        : [emptyNode('ICT Function Data', entityItem.entity_id, eIndex)];

    children.push(...serviceDataNodes, ...functionDataNodes);

    return createNode(
      getKey('entity', entityItem.entity_id, eIndex),
      'Entity',
      entityItem.entity_name,
      {
        entity_start_date: entityItem.entity_start_date,
        entity_end_date: entityItem.entity_end_date,
      },
      children,
    );
  });
};
